export const css = {
    root: '_2e-zMzeV',
    pane: '_2It4hdad',
    heading: 't9TiNIA9',
    body: 'ylqQc4hu',
    exit: '_3-WcQCF_',
    collapse: 'x0Gpjt-M',
    enter: '_1wL0qroo',
    expand: 'Rz4-wsSx',
    ' _key': 'certwise-theme/certwise/base-widgets/accordion2'
};
export default css;
